import LessonInfoForm from "./LessonInfoForm";

export default function LessonForm({ row: lessonRow, onEdit, onCreate }) {
  return <LessonInfoForm lesson={lessonRow} onEdit={onEdit} onCreate={onCreate} />;
}
